import React from 'react'
import { useNavigate } from 'react-router-dom'
import './VerticalMissions.css'

const VerticalMissions = () => {
  const navigate = useNavigate()
  
  return (
    <div id="mission" className="section-container">
      <div className="mission-max-width max-width">
        <span className="mission-heading beforeHeading">Our Mission</span>
        <h1 className="mission-title">
          Provide a vital service to outdoor spaces everywhere
        </h1>
        
        <div className="mission-cards-container">
          {/* First card - Text on LEFT, image on RIGHT */}
          <div className="mission-card">
            <div className="mission-card-content">
              <div className="mission-card-text-container">
                <h2 className="mission-card-title">Prevent skin cancer</h2>
                <p className="mission-card-text">Help prevent skin cancer with an <strong className="brand-orange bold-text">affordable sunscreen</strong> option.</p>
                <button 
                  className="mission-card-button"
                  onClick={() => navigate('/product')}
                >
                  Learn About Our Products
                </button>
              </div>
              <div className="mission-card-image sunburn-bg"></div>
            </div>
          </div>
          
          {/* Second card - Text on RIGHT, image on LEFT */}
          <div className="mission-card">
            <div className="mission-card-content reverse">
              <div className="mission-card-text-container">
                <h2 className="mission-card-title">Moisturize</h2>
                <p className="mission-card-text">Be kind to your skin and moisturize with <strong className="brand-orange bold-text">high quality sunscreen</strong>.</p>
                <button 
                  className="mission-card-button"
                  onClick={() => navigate('/sunscreen-facts')}
                >
                  Explore Sunscreen Benefits
                </button>
              </div>
              <div className="mission-card-image moisturize-bg"></div>
            </div>
          </div>
          
          {/* Third card - Text on LEFT, image on RIGHT */}
          <div className="mission-card">
            <div className="mission-card-content">
              <div className="mission-card-text-container">
                <h2 className="mission-card-title">Reduce single-use plastics</h2>
                <p className="mission-card-text">Reduce waste and <strong className="brand-orange bold-text">harmful microplastics</strong> with our dispenser.</p>
                <button 
                  className="mission-card-button"
                  onClick={() => navigate('/sunscreen-facts#environmental-impact')}
                >
                  See Environmental Impact
                </button>
              </div>
              <div className="mission-card-image plastic-bg"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VerticalMissions